import apiClient from './client';

export interface MyPlanterProfile {
  id: number;
  name: string;
  spouseName?: string | null;
  email?: string | null;
  phone?: string | null;
  city?: string | null;
  state?: string | null;
  churchName?: string | null;
  supportingChurch?: string | null;
  assignedHub?: string | null;
  assignedHubLeader?: number | null;
  hubLeader?: {
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
  } | null;
  headshotImagePath?: string | null;
  familyPhotoImagePath?: string | null;
  mbcbReportingEnabled: boolean;
}

export interface PlanterNetworkImpact {
  scope: string;
  totalBaptisms: number;
  totalCooperativeProgramGiving: number;
  plantsInFundingOrPostFunding: number;
  mbcbReportStatusesIncluded: string[];
}

class PlanterService {
  async getMyPlanter(): Promise<MyPlanterProfile> {
    const response = await apiClient.get('/planters/me');
    return response.data.data;
  }

  async getNetworkImpact(): Promise<PlanterNetworkImpact> {
    const response = await apiClient.get('/planters/network-impact');
    return response.data.data;
  }
}

export const planterService = new PlanterService();
